import { Directive, HostListener, Input } from '@angular/core';

import { NavigationService } from '@frontend/vanilla/core';

import { Link } from '../models/models';

@Directive({
    selector: '[paOpenLink]',
    standalone: true,
})
export class PaymentsOpenLinkDirective {
    @Input('paOpenLink') link: Link = {};
    @Input('url') doNothing = false;

    constructor(private navigationService: NavigationService) {}

    @HostListener('click', ['$event'])
    async onClick() {
        if (this.doNothing) {
            return;
        }
        if (this.link.url) {
            let options = {};
            if (this.link.target) {
                options = { forceReloadTarget: this.link.target.replace('_', '') };
            }
            await this.navigationService.goTo(this.link.url, options);
        }
    }
}
//TODO: implement tracking logic here
